import { useEffect, useState } from "react";
import { useDashboard } from "../../../lib/useDashboard";
import { getInitialBoolean } from "@/shared/lib/localStorage";
import { MainTypesPlans } from "../../../model/dashboard.types";
import { useDashboardActions } from "../../../lib/useDashboardActions";
import { useAuth } from "@/features/Auth/lib/useAuth";

const useCompanyPlan = () => {

  const {
    dateStart, 
    dateEnd, 
    companyPlanResultOpportunity : opportunityResult, 
    setCompanyPlanResultOpportunity: setOpportunityResult,
    companyPlanResultProfit: profitResult,
    setCompanyPlanResultProfit: setProfitResult,
    loading,
    error
  } = useDashboard()

  const {
    getCompanyPlanResult
  } = useDashboardActions();

  const { 
    isAuth 
  } = useAuth();


  const OPP_IS_PERIOD_KEY = 'useCompanyPlan_opportunity_isPeriod';
  const PROF_IS_PERIOD_KEY = 'useCompanyPlan_profit_isPeriod';

  const [opportunityIsPeriod, setOpportunityIsPeriod] = useState<boolean>(getInitialBoolean(OPP_IS_PERIOD_KEY, false));
  const [profitIsPeriod, setProfitIsPeriod] = useState<boolean>(getInitialBoolean(PROF_IS_PERIOD_KEY, false));

  useEffect(() => {
    localStorage.setItem(OPP_IS_PERIOD_KEY, String(opportunityIsPeriod));
  }, [opportunityIsPeriod]);
  useEffect(() => {
    localStorage.setItem(PROF_IS_PERIOD_KEY, String(profitIsPeriod));
  }, [profitIsPeriod]);

  useEffect(() => {
    if (isAuth && dateStart && dateEnd) {
      (async () => {
        const result = await getCompanyPlanResult({
          dateStart,
          dateEnd,
          isPeriod: opportunityIsPeriod,
          type: MainTypesPlans.opportunitie
        });
        setOpportunityResult(result);
      })();
    }
    // eslint-disable-next-line
  }, [isAuth, dateStart, dateEnd, opportunityIsPeriod]);

  useEffect(() => {
    if (isAuth && dateStart && dateEnd) {
      (async () => {
        const result = await getCompanyPlanResult({
          dateStart,
          dateEnd,
          isPeriod: profitIsPeriod,
          type: MainTypesPlans.profit
        });
        setProfitResult(result);
      })();
    }
    // eslint-disable-next-line
  }, [isAuth, dateStart, dateEnd, profitIsPeriod]);

  return {
    opportunity: {
      result: opportunityResult,

      // for popup
      isPeriod: opportunityIsPeriod,
      setIsPeriod: setOpportunityIsPeriod
    },
    profit: {
      result: profitResult,

      // for popup
      isPeriod: profitIsPeriod,
      setIsPeriod: setProfitIsPeriod
    },
    loading: loading.dashboardCompanyPlanResult,
    error: error.dashboardCompanyPlanResult
  }
}

export { useCompanyPlan }